module.exports = __webpack_public_path__ + "static/hive-007fb49f00acbaf4acb6194ebbc1f359.png";